// extracted by mini-css-extract-plugin
export default {"walkthroughContainer":"walkthrough_walkthroughContainer__DMEhq","title":"walkthrough_title__h-kPl","video":"walkthrough_video__zc2RE"};